import { RefreshCcw, Upload } from "lucide-react";
import { RoleBasedLayout } from "../../components/RoleBasedLayout";
import { exportProductsPdf } from "../../lib/exportSalesPDF";
import ProductSalesTable from "../../components/ProductSalesTable";
import SalesFilters from "../../components/SalesFilter";
import { useProducts } from "../../hooks/useProducts";
import RecentSalesSkeleton from "../../components/RecentSalesTableSkeleton";
import { useAppDispatch } from "../../hooks";
import type { SalesHistoryFilters } from "../../slices/salesSlice";
import { useEffect, useState } from "react";
import { fetchProductHistory, updateHistoryFilters } from "../../slices/productSlice";


const ProductSalesHistoryPage: React.FC = () => {
    const { productHistory, loading } = useProducts();
    const dispatch = useAppDispatch();

    const [filters, setFilters] = useState<SalesHistoryFilters>({
        storeId: null,
        productId: null,
        startDate: null,
        endDate: null
    });

    const handleFilterChange = (partials: Partial<SalesHistoryFilters>) => {
        setFilters((prev) => ({
            ...prev,
            ...partials
        }));
    };

    useEffect(() => {
        console.log("Filters: ", filters);
        dispatch(updateHistoryFilters(filters));
        dispatch(fetchProductHistory());
      }, [filters, dispatch])

    console.log("Products: ", productHistory);

  return (
    <RoleBasedLayout>
      <div className="p-6 space-y-6">
        <div className="flex flex-col md:flex-row md:justify-end gap-3">

            <button
                onClick={() => exportProductsPdf(productHistory)}
                className="flex items-center gap-2 px-4 py-4 rounded-md bg-primary hover:bg-blue-900 text-white"
            >
                <Upload />
                Export to PDF
            </button>
             <button
                onClick={() => dispatch(fetchProductHistory())}
                className="flex items-center gap-2 px-4 py-4 rounded-md border border-gray-600 text-gray-700 hover:border-gray-900"
            >
                <RefreshCcw />
                Refresh
            </button>
        </div>

        <SalesFilters onFilterChange={handleFilterChange} />

        {
            loading ? (
                <RecentSalesSkeleton />
            ) : (
                <ProductSalesTable products={productHistory} />
            )
        }
      </div>
    </RoleBasedLayout>
  );
};

export default ProductSalesHistoryPage;
